module.exports = {
    publicPath: "/blackholesuns/",
    configureWebpack: {
        module: {
            rules: [],
        },
    },
};
